import React, { Component } from 'react';
import { QueryVSContext } from '../contexts/QueryVSContext';
import Button from '@material-ui/core/Button';
import './ValueSetPage.css';

class ValueSetPage extends Component {
	static contextType = QueryVSContext;

	handleClick() {
		document.getElementById('valueSetBody__id').scroll({ top: 0, behavior: 'auto' });
	}

	render() {
		const { getNext, getPrev } = this.context;

		// console.log(this.props);
		return (
			<div className="valueSetPage">
				<Button
					variant="contained"
					size="small"
					color="primary"
					className="valueSetPage__button"
					disabled={!this.props.prev}
					onClick={(x) => {
						this.handleClick();
						getPrev();
					}}
				>
					Prev
				</Button>
				<Button
					variant="contained"
					size="small"
					color="primary"
					className="valueSetPage__button"
					disabled={!this.props.next}
					onClick={(x) => {
						this.handleClick();
						getNext();
					}}
				>
					Next
				</Button>
			</div>
		);
	}
}
export default ValueSetPage;
